/* Print Lab v3: point every "create your own" entry at the designer */
(function(){
  var D='/pages/design';
  document.querySelectorAll('a[href]').forEach(function(a){
    var h=a.getAttribute('href')||'';
    if(/\/collections\/custom-apparel\/?$/.test(h) && (a.closest('header')||a.closest('.menu-drawer')||a.closest('.pl-hero')||a.closest('.pl-steps__cta')||a.closest('.pl-split'))) a.setAttribute('href',D);
  });
})();
/* cart: show the customer's mockup as the line image */
(function(){
  function swap(){
    document.querySelectorAll('.cart-item').forEach(function(row){
      var link=[].slice.call(row.querySelectorAll('.product-option a, dd a, a')).find(function(a){return /\/uploads\//.test(a.href)&&/preview/i.test((a.closest('.product-option')||a.parentNode).textContent);});
      var img=row.querySelector('.cart-item__image');
      row.querySelectorAll('a[href*="/uploads/"]').forEach(function(a){if(!a.dataset.pl){a.dataset.pl='1';a.textContent='View';a.target='_blank';}});
      if(link&&img&&img.dataset.plSwapped!=='1'){img.src=link.href;img.srcset='';img.dataset.plSwapped='1';img.style.background='#e9e7e2';}
    });
  }
  swap(); document.addEventListener('cart:refresh',swap); new MutationObserver(swap).observe(document.body,{childList:true,subtree:true});
})();
/* product page: hide the "Print" option picker (the designer picks it) */
(function(){ document.querySelectorAll('.product-form__input, variant-selects fieldset, variant-selects .product-form__input').forEach(function(f){ var l=f.querySelector('legend, .form__label'); if(l&&/^\s*Print\s*$/i.test(l.textContent)) f.style.display='none'; }); })();